<div class="h-full overflow-hidden">
  <p-scroll-panel class="h-full">
    <form [formGroup]="form">
      <div class="control">
        <label>Regnr</label>
        <input pInputText formControlName="regnr" />
      </div>
      <div class="control">
        <label>Opkrævningsperiode</label>
        <p-select
          [options]="periodeOptions()"
          [showClear]="true"
          formControlName="leverandoerOpkraevningPeriodeId"
          optionLabel="text"
          optionValue="value"
          appendTo="body" />
      </div>
      <div class="control">
        <label>Status</label>
        <p-select
          [options]="statusOptions"
          [showClear]="true"
          formControlName="status"
          optionLabel="text"
          optionValue="value"
          appendTo="body" />
      </div>

      <div class="flex gap-2">
        <p-button
          label="Søg"
          (click)="onClickSearch()"
          [loading]="leverandoerOpkraevningService.datasource.isLoading()"
          icon="pi pi-search"
          type="submit" />
        <p-button
          label="Nulstil"
          (click)="onClickReset()"
          icon="pi pi-times"
          severity="secondary"
          outlined />
      </div>
    </form>
    @if (noHits()) {
      <p-message text="Ingen hits" severity="error" styleClass="mt-4" />
    }
  </p-scroll-panel>
</div>
